import { ChevronDown } from "lucide-react";

const ITEMS = [
  {
    question: "支持哪些 PDF 文件？",
    answer:
      "当前支持 25 MiB 以内的标准 PDF 文件。密码保护、损坏或超大文件暂不支持。",
  },
  {
    question: "转换后的 Word 会保留原格式吗？",
    answer:
      "系统会尽量保留标题、段落和基本排版。复杂表格、扫描件和特殊字体可能需要在 Word 中微调。",
  },
  {
    question: "我的文件会被保存吗？",
    answer:
      "不会保存任何历史记录。关闭页面时会立即请求清理原 PDF 和 DOCX，服务端还有最长 10 分钟的兜底清理。",
  },
] as const;

export function Faq() {
  return (
    <section className="faq-section" id="faq">
      <h2>常见问题</h2>
      <div className="faq-list">
        {ITEMS.map(({ question, answer }) => (
          <details key={question}>
            <summary>
              <span>{question}</span>
              <ChevronDown size={18} />
            </summary>
            <p>{answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
